'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import { apiGtm } from '@/api/gtm';
import { InvisibleCaptcha } from '@/api/yandex-captcha';
import { UiLegalConsentCheckbox } from '@/ui/legal-consent-checkbox';
import { UiKitButton } from '@/ui-kit/button';
import { UiKitInput } from '@/ui-kit/input';
import { useForm } from '@/ui-tool/form';

import { formAction } from '../../api/formAction';

import { styles } from './Form.styles';

export interface FormProps {
  className?: string;
  onReset?: () => void;
}

export function Form({ className, onReset }: FormProps) {
  const slots = styles();
  const t = useTranslations();
  const [captchaToken, setCaptchaToken] = useState('');

  const { getFieldProps, state, action, isDirty, pending } = useForm(formAction, {});

  useEffect(() => {
    if (state.status === 'success' && isDirty) {
      apiGtm.newsletterRegistration('footer');
      onReset?.();
    }
  }, [state.status, isDirty, onReset]);

  const agreementFromServer =
    state.data?.agreement === true || state.data?.agreement === 'on';

  return (
    <form
      className={slots.base({ className })}
      noValidate
      action={action}
    >
      <UiKitInput
        name="email"
        label={t('subscription.placeholder')}
        {...getFieldProps('email')}
      />

      <UiLegalConsentCheckbox
        key={state.data ? `agreement-${String(agreementFromServer)}` : 'agreement'}
        defaultChecked={state.data ? agreementFromServer : true}
        withAdsConsent
        {...getFieldProps('agreement')}
      />

      <div>
        <InvisibleCaptcha
          onSuccess={setCaptchaToken}
          visible
        />
        <input
          type="hidden"
          name="recaptcha_token"
          value={captchaToken}
        />

        <UiKitButton
          className={slots.button()}
          type="submit"
          loading={pending}
        >
          {t('subscribe')}
        </UiKitButton>
      </div>
    </form>
  );
}
